import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=50410b0d&scoped=true"
import script from "./similar.vue?vue&type=script&lang=js"
export * from "./similar.vue?vue&type=script&lang=js"
import style0 from "./similar.vue?vue&type=style&index=0&id=50410b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50410b0d",
  null
  
)

export default component.exports